module.exports = __webpack_public_path__ + "static/media/display13.75daf47a.jpg";